interface SubmitButtonProps {
  isDirty: boolean
  isSubmitting: boolean
  isPending: boolean
}

export const SubmitButton = ({
  isDirty,
  isSubmitting,
  isPending,
}: SubmitButtonProps) => (
  <div className="flex justify-end">
    <button
      type="submit"
      disabled={!isDirty || isSubmitting || isPending}
      className="btn btn-success transition-bg btn-small disabled:opacity-70"
    >
      {isSubmitting || isPending ? 'Updating...' : 'Update'}
    </button>
  </div>
)
